<template>
  <a-layout class="role-manage">
    <a-layout-sider width="280" style="background: #fff;padding:16px 0 16px 16px">
      <role-tree></role-tree>
    </a-layout-sider>
    <a-layout-content style="background: #fff;padding: 16px">
      <div class="content">
        <a-tabs defaultActiveKey="1" @change="callback">
          <a-tab-pane forceRender tab="人员角色分配" key="1">
            <!-- list列表 -->
            <table-list ref="tableList"></table-list>
          </a-tab-pane>
          <a-tab-pane forceRender tab="菜单角色分配" key="2">
            <!-- 权限tree -->
            <table-tree ref="tableTree"></table-tree>
          </a-tab-pane>
          <a-tab-pane forceRender tab="公司权限分配" key="4">
            <!-- 公司权限分配 -->
            <company-tree ref="companyTree"></company-tree>
          </a-tab-pane>
          <a-tab-pane forceRender tab="使用部门分配" key="5">
            <!-- 使用部门分配 -->
            <use-dept-tree ref="useDeptTree"></use-dept-tree>
          </a-tab-pane>
          <a-tab-pane forceRender tab="资产归口权限配置" key="3">
            <!-- 归口部门权限分配 -->
            <data-tree ref="tableTree"></data-tree>
          </a-tab-pane>
          <a-tab-pane forceRender tab="资产分类权限" key="6">
            <!-- 资产分类权限 -->
            <asset-type-permission ref="assetTypePermission"></asset-type-permission>
          </a-tab-pane>
          <a-tab-pane forceRender tab="设备分类权限" key="7">
            <!-- 设备分类权限 -->
            <device-type-permission ref="deviceTypePermission"></device-type-permission>
          </a-tab-pane>
          <a-tab-pane forceRender tab="设备归口权限配置" key="8">
            <!-- 设备归口权限配置 -->
            <configure-equipment-permission ref="configureEquipmentPermission"></configure-equipment-permission>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import roleTree from './tree.vue'
import tableList from './list.vue'
import tableTree from './table.vue'
import dataTree from './dataTree.vue'
import CompanyTree from './companyTree.vue'
import UseDeptTree from './useDeptTree.vue'
import assetTypePermission from './assetTypePermission.vue'
import deviceTypePermission from './deviceTypePermission.vue'
import configureEquipmentPermission from '@/views/sysManagement/role2/configureEquipmentPermission.vue'
export default {
  components: {
    roleTree,
    tableList,
    tableTree,
    dataTree,
    CompanyTree,
    UseDeptTree,
    assetTypePermission,
    deviceTypePermission,
    configureEquipmentPermission
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    // 切换tab页回调
    callback () {}
  }
}
</script>
<style lang="less" scoped>
///deep/.ant-tabs {
//  height: 100%;
//}
</style>